import MainContainer from "./components/ColorChoiceContainer";
import * as actions from "./actions";
import * as selectors from "./selectors";
import reducer, { ColorChoiceState } from "./reducer";

export { actions, reducer, selectors, ColorChoiceState as State };

export default MainContainer;



// WEBPACK FOOTER //
// ./src/routes/WizardColorChoice/index.ts